import type { ReactElement } from 'react';

import { CmsView, type CmsViewProps } from '@/views/CmsView';
import { StrapMaterialView } from '@/views/StrapMaterialView/StrapMaterialView';
import type { StrapMaterialViewProps } from '@/views/StrapMaterialView/types';
type StrapMaterialViewWrapperProps = (StrapMaterialViewProps | CmsViewProps) & {
  isStrapMaterialView?: boolean;
};

export const StrapMaterialViewWrapper = (
  props: StrapMaterialViewWrapperProps,
) => {
  return props?.isStrapMaterialView ? (
    <StrapMaterialView {...(props as StrapMaterialViewProps)} />
  ) : (
    <CmsView {...(props as CmsViewProps)} />
  );
};

StrapMaterialViewWrapper.getLayout = (page: ReactElement) => {
  if (page.props?.isStrapMaterialView) {
    return StrapMaterialView.getLayout(page);
  } else {
    return CmsView.getLayout(page);
  }
};
